import axios, { AxiosResponse } from "axios";
import { getBackendUrl } from "../../../utils";
import {
  BankFeedAccountLinkingData,
  ErrorArgs,
  PENDING_LINKING_DATA_KEY,
} from "../constants";
import { getMessageFromError } from "./shared";

export const generateGetAccountLinkingValues = (
  trackStepOneAmplitudeEvent: (msg: string, props: any) => void,
): ((key: string) => BankFeedAccountLinkingData[]) => {
  return (key: string) => {
    const item = localStorage.getItem(key);
    if (!item) {
      return [];
    }
    try {
      if (key === PENDING_LINKING_DATA_KEY) {
        const data = JSON.parse(item);
        return Object.values(data) as BankFeedAccountLinkingData[];
      }

      return JSON.parse(item);
    } catch (err) {
      trackStepOneAmplitudeEvent("Error retrieving account linking data", {
        key,
        errorMessage: getMessageFromError(err),
      });
      return [];
    }
  };
};

export const fetchAllEntitiesWithPagination = async (
  entityMetadata: {
    endpoint: string;
    key: string;
    description: string;
  },
  stateMetadata: {
    token: string;
    updateItemDetails: (apiResponse: AxiosResponse<any>) => void;
    updateErrorMessage: (args: ErrorArgs) => void;
    trackStepOneAmplitudeEvent: (msg: string, props?: any) => void;
  },
  handleFetchedResults: (entities: any[]) => void,
) => {
  const { endpoint, key, description } = entityMetadata;
  const {
    token,
    updateItemDetails,
    updateErrorMessage,
    trackStepOneAmplitudeEvent,
  } = stateMetadata;
  let nextCursor = null;
  let entities: any[] = [];
  let fetchedItemId;

  do {
    try {
      const response: AxiosResponse = await axios.get(
        `${getBackendUrl()}/versioned/accounting/${endpoint}`,
        {
          headers: {
            "X-Rutter-Lta": token,
            "X-Rutter-Version": "2024-08-31",
          },
          params: {
            limit: 500,
            cursor: nextCursor,
          },
        },
      );

      const fetchedEntities = response.data[key];
      fetchedItemId = fetchedItemId ?? response.data?.connection?.id;
      trackStepOneAmplitudeEvent(`Loaded intermediary ${description}`, {
        itemId: fetchedItemId,
        count: fetchedEntities.length,
      });

      updateItemDetails(response);

      entities = entities.concat(fetchedEntities);
      nextCursor = response.data.next_cursor;
    } catch (err) {
      trackStepOneAmplitudeEvent(`Error loading ${description}.`);
      updateErrorMessage({ error: err });
      return;
    }
  } while (nextCursor);

  trackStepOneAmplitudeEvent(`Finished loading ${description}`, {
    itemId: fetchedItemId,
    count: entities.length,
  });

  handleFetchedResults(entities);
};
